module.exports = __webpack_public_path__ + "static/img/collection.b29bb15d.jpg";